import { render, staticRenderFns } from "./Fact.vue?vue&type=template&id=66a6bf8b&"
import script from "./Fact.vue?vue&type=script&lang=js&"
export * from "./Fact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports